// extracted by mini-css-extract-plugin
export default {"secondary-slides":"THXsj"};